/**
 * Registre centralisé des classes Font Awesome.
 *
 * Le CDN chargé dans `public/index.html` est **Font Awesome 6 Free** : seuls les
 * styles `fa-solid` et `fa-brands` sont complets, `fa-regular` ne couvre qu'une
 * poignée de glyphes, et `fa-light` / `fa-thin` / `fa-duotone` / `fa-sharp`
 * n'existent pas. Une classe Pro s'affiche comme un carré vide en production.
 *
 * Toutes les icônes passent par ce fichier pour que `fontawesome.test.js` puisse
 * les valider statiquement. Ne pas écrire de classe `fa-*` ailleurs.
 */
export const ICONS = {
  // Header
  language: "fa-solid fa-globe",

  // Navigation
  navAbout: "fa-regular fa-address-card",
  navResume: "fa-regular fa-file-lines",
  navPortfolio: "fa-solid fa-briefcase",

  // Informations personnelles
  phone: "fa-solid fa-mobile-screen-button",
  email: "fa-regular fa-envelope",
  location: "fa-solid fa-location-dot",
  download: "fa-solid fa-download",

  // Compétences
  skillFrontend: "fa-solid fa-swatchbook",
  skillBackend: "fa-solid fa-server",
  skillFramework: "fa-solid fa-layer-group",
  skillDatabase: "fa-solid fa-database",
  skillData: "fa-solid fa-chart-line",
  skillOthers: "fa-solid fa-code",

  // CV
  education: "fa-solid fa-graduation-cap",
  experience: "fa-solid fa-briefcase",
  leadership: "fa-solid fa-users",
  award: "fa-solid fa-award",

  // Réseaux sociaux
  socialGithub: "fa-brands fa-github",
  socialLinkedin: "fa-brands fa-linkedin-in",
  socialEmail: "fa-regular fa-envelope",

  // Portfolio
  technologies: "fa-solid fa-code",
  github: "fa-brands fa-github",
  website: "fa-solid fa-globe",
  close: "fa-solid fa-xmark",
  lock: "fa-solid fa-lock",

  // Contrôles
  chevronRight: "fa-solid fa-chevron-right",
  chevronUp: "fa-solid fa-chevron-up",
  chevronDown: "fa-solid fa-chevron-down",
};
